
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData'],
      ({ compData }) => {
        return {
          ...{"suffixIcon":{},"prefixIcon":{},"weight":"normal","skin":"standard","size":"medium","url":"","text":"Text Button"},
          ...compData,
          
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  